import { EditSharp, RemoveRedEye, AssignmentReturn } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Modal,
  Stack,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Routes } from "src/constant/api_url";
import {
  getPrimeStockHistory,
  revokePrimeProductFromMember,
  updatePrimeStockInData
} from "src/api/primestockapi";
import Page from "src/components/Page";
import Select from "react-select";
import { notification } from "src/utils/messages";
import { IsNotValue, statusLabel } from "src/constant/variable";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enGB } from "date-fns/locale";
import { saveAs } from "file-saver";
import CustomLoader from "src/components/CustomLoader";
import { CSVLink } from "react-csv";
import { canAddStock, canRevokeStock, getLoggedInUser } from "src/utils/stockPermission";

export default function ProductHistory({ productHistoryPage, setProductHistoryPage, rowData }) {
  const approveModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };
  // Prime roles: Main Admin / Sub Admin / Staff. No city impersonation.
  const loginUser = getLoggedInUser();
  const canAddStockLine = canAddStock(loginUser);
  const canRevoke = canRevokeStock(loginUser);
  const csvLinkRef = React.useRef();

  const [isLoading, setIsLoading] = useState(false);

  const [tabValue, setTabValue] = useState(0);
  const [page, setPage] = useState(1);
  const [outPage, setOutPage] = useState(1);
  const [rowPerPage, setRowsPerPage] = useState(10);
  const [outRowPerPage, setOutRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchCall, setSearchCall] = useState(false);
  const [searchClearCall, setSearchClearCall] = useState(false);
  const [stockInCounter, setStockInCounter] = useState(0);
  const [stockOutCounter, setStockOutCounter] = useState(0);
  const [exporting, setExporting] = useState(false);
  const [exportData, setExportData] = useState([]);
  const [stockData, setStockData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [stockOutRowData, setStockOutRowData] = useState([]);
  const [stockInRowData, setStockInRowData] = useState([]);
  const [editStockModal, setEditStockModal] = useState(false);
  const [viewAttachmentModal, setViewAttachmentModal] = useState(false);
  const [attachmentData, setAttachmentData] = useState([]);
  const [revokeConfirmationModal, setRevokeConfirmationModal] = useState(false);

  const [filtereddata, setFilteredData] = useState({
    search: "",
    s_status: -1
  });

  const toggleEditModal = () => setEditStockModal(!editStockModal);
  const toggleViewAttachmentModal = () => setViewAttachmentModal(!viewAttachmentModal);

  const handleGetStockHistoryData = async (data, filterData, isExport = 0) => {
    setIsLoading(true);
    const resp = await getPrimeStockHistory({
      p_id: rowData.p_id,
      page: data == 0 ? page : outPage,
      per_page: data == 0 ? rowPerPage : outRowPerPage,
      tab: data == 0 ? 1 : 2,
      s_date: filterData.s_date,
      e_date: filterData.e_date,
      sh_status: filterData?.s_status,
      search: filterData?.search,
      is_export: isExport
    });
    setIsLoading(false);

    if (isExport) {
      setExportData(resp?.data?.data || []);
      setTimeout(() => {
        csvLinkRef.current.link.click(); // auto download
        setExporting(false);
      }, 100);
      return;
    }
    if (resp.status == 1) {
      setStockData(resp?.data?.data);
      setTotalRows(resp?.data.counter);
      setStockOutCounter(resp.data?.stock_out_counter);
      setStockInCounter(resp.data?.stock_in_counter);
    }
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    handleGetStockHistoryData(newValue, filtereddata);
  };

  const handleRevokeProduct = async (statusData) => {
    setLoader(true);
    const res = await revokePrimeProductFromMember({
      m_p_a_id: statusData.mpa_id || statusData.m_p_a_id,
      u_id: loginUser?.u_id,
      u_name: loginUser?.name,
      date: moment().format("DD-MM-YYYY"),
      reason: "Revoked from Product History"
    });

    let notify = notification({
      type: res.status == 0 ? "error" : "success",
      message: res.message
    });
    notify();
    if (res.status != 0) {
      handleGetStockHistoryData(tabValue, filtereddata);
    }
    setLoader(false);
  };

  const handleUpdateStockIn = async (statusData) => {
    setLoader(true);
    const res = await updatePrimeStockInData({
      sh_id: statusData.sh_id,
      p_id: rowData.p_id,
      p_qty: statusData.qty,
      date: moment().format("DD-MM-YYYY"),
      q_c_name: statusData.q_c_name,
      courier_price: statusData.courier_price
    });
    let notify = notification({
      type: res.status == 0 ? "error" : "success",
      message: res.message
    });
    notify();
    if (res.status != 0) {
      handleGetStockHistoryData(tabValue, filtereddata);
    }
    setLoader(false);
  };

  const handleExportCSV = async () => {
    setExporting(true);
    setIsLoading(true);
    await handleGetStockHistoryData(tabValue, filtereddata, 1);
    setIsLoading(false);
  };

  useEffect(() => {
    handleGetStockHistoryData(tabValue, filtereddata);
  }, [page, outPage, rowPerPage, outRowPerPage]);

  const CustomBadges = ({ counter }) => {
    return (
      <div
        style={{
          background: "#034766",
          color: "#fff",
          padding: "2px 10px",
          borderRadius: "10px",
          marginLeft: "5px"
        }}
      >
        <span>{counter != undefined ? counter : 0}</span>
      </div>
    );
  };

  const conditionalRowStyles = [
    {
      when: (row) => row?.is_purchased === 1,
      style: {
        backgroundColor: "#86f2baff",
        color: "#000"
      }
    }
  ];

  const stockInColumns = [
    { name: "No", selector: (row, index) => index + 1 + (page - 1) * rowPerPage, width: "100px" },
    {
      name: "Date",
      width: "200px",
      selector: (row) => row?.sh_date
    },
    {
      name: "Quantity",
      width: "120px",
      selector: (row) => row?.qty
    },
    {
      name: "Courier Type",
      wrap: true,
      selector: (row) => row?.type_name || "-"
    },
    {
      name: "Courier Price",
      wrap: true,
      selector: (row) => row?.courier_price || 0
    },
    {
      name: "QC Name",
      wrap: true,
      selector: (row) => row?.q_c_name || "-"
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      width: "200px",
      selector: (row) => (
        <>
          {canAddStockLine && (
            <Tooltip title="Edit Stock">
              <IconButton
                onClick={() => {
                  setStockInRowData({ ...row, p_name: rowData.p_name });
                  setEditStockModal(true);
                }}
              >
                <EditSharp color="warning" />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title="View Attachments">
            <IconButton
              onClick={() => {
                setAttachmentData(row);
                toggleViewAttachmentModal();
              }}
            >
              <RemoveRedEye color="light" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  const stockOutColumns = [
    {
      name: "No",
      selector: (row, index) => index + 1 + (outPage - 1) * outRowPerPage,
      width: "70px"
    },
    {
      name: "Date",
      wrap: true,
      selector: (row) => row.sh_date
    },
    {
      name: "Quantity",
      wrap: true,
      selector: (row) => row?.qty
    },
    {
      name: "Member Name",
      wrap: true,
      width: "270px",
      selector: (row) => row?.member_name || "-"
    },
    {
      name: "Contact No",
      wrap: true,
      width: "150px",
      selector: (row) => row?.mobile_no || "-"
    },
    {
      name: "Type",
      wrap: true,
      width: "130px",
      selector: (row) =>
        parseInt(row?.is_purchased) === 1 ? (
          <span style={{ color: "#f59e0b", fontWeight: 600 }}>Purchased</span>
        ) : (
          <span style={{ color: "#54D62C", fontWeight: 600 }}>Free</span>
        )
    },
    {
      name: "Amount",
      wrap: true,
      width: "110px",
      selector: (row) => (parseFloat(row?.amount) > 0 ? `₹${row.amount}` : "-")
    },
    {
      name: "QC Name",
      wrap: true,
      selector: (row) => row?.q_c_name || "-"
    },
    {
      name: "Assign By",
      wrap: true,
      selector: (row) => row?.u_name || "-"
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      width: "200px",
      selector: (row) => (
        <>
          {canRevoke && (
            <Tooltip title="Revoke">
              <IconButton
                onClick={() => {
                  setStockOutRowData({ ...row, p_name: rowData.p_name });
                  setRevokeConfirmationModal(true);
                }}
              >
                <AssignmentReturn color="secondary" />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title="View Attachments">
            <IconButton
              onClick={() => {
                setAttachmentData(row);
                toggleViewAttachmentModal();
              }}
            >
              <RemoveRedEye color="light" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  const stock_in_columns = [
    { label: "Date", key: "sh_date" },
    { label: "Quantity", key: "qty" },
    { label: "Courier Price", key: "courier_price" },
    { label: "QC Name", key: "q_c_name" }
  ];

  const stock_out_columns = [
    { label: "Date", key: "sh_date" },
    { label: "Quantity", key: "qty" },
    { label: "Member Name", key: "member_name" },
    { label: "Amount", key: "amount" },
    { label: "QC Name", key: "q_c_name" },
    { label: "Assign By", key: "u_name" }
  ];

  const stockInExpandableRow = ({ data }) => {
    return (
      <div style={{ padding: "5px 15px", backgroundColor: "#f3f3f39c" }}>
        {data?.description != null && data?.description != "" && (
          <p>
            <b>Description</b> : {data?.description}
          </p>
        )}
      </div>
    );
  };

  return (
    <>
      <Page title="Product History">
        <Container maxWidth="md">
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Product History ({rowData.p_name})
            </Typography>
            <div>
              <Button variant="contained" onClick={() => setProductHistoryPage(false)}>
                Back
              </Button>
            </div>
          </Stack>
          <Card className="p-20">
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} md={4}>
                <Stack spacing={3}>
                  <label style={{ marginBottom: "5px" }}>Select Status</label>
                  <Select
                    value={statusLabel?.find((opt) => opt.value == filtereddata?.s_status)}
                    menuPortalTarget={document.body}
                    onChange={(e) => {
                      setFilteredData({
                        ...filtereddata,
                        s_status: e.value
                      });
                      setSearchCall(true);
                    }}
                    options={statusLabel}
                  />
                </Stack>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Stack spacing={0}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                    <label style={{ marginBottom: "5px" }}>Select Start Date</label>
                    <DatePicker
                      size="small"
                      sx={{ width: "100%" }}
                      name="s_date"
                      inputFormat="dd/MM/yyyy"
                      value={
                        filtereddata.s_date != null
                          ? moment(filtereddata.s_date, "DD-MM-YYYY")
                          : null
                      }
                      onChange={(newDate) => {
                        setSearchCall(true);
                        setFilteredData({
                          ...filtereddata,
                          s_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                        });
                      }}
                      renderInput={(params) => <TextField {...params} size="small" />}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Stack spacing={0}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                    <label style={{ marginBottom: "5px" }}>Select End Date</label>
                    <DatePicker
                      size="small"
                      sx={{ width: "100%" }}
                      name="e_date"
                      inputFormat="dd/MM/yyyy"
                      value={
                        filtereddata.e_date != null
                          ? moment(filtereddata.e_date, "DD-MM-YYYY")
                          : null
                      }
                      onChange={(newDate) => {
                        setSearchCall(true);
                        setFilteredData({
                          ...filtereddata,
                          e_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                        });
                      }}
                      renderInput={(params) => <TextField {...params} size="small" />}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid item xs={3} style={{ marginTop: "7px" }}>
                <Stack spacing={0}>
                  <TextField
                    fullWidth
                    size="small"
                    autoComplete="off"
                    type="text"
                    label="Search"
                    name="search_text"
                    value={filtereddata.search}
                    onChange={(e) => {
                      setSearchCall(true);
                      setFilteredData({ ...filtereddata, search: e.target.value });
                    }}
                  />
                </Stack>
              </Grid>

              <Grid
                item
                xs={2}
                lg={2}
                md={2}
                sm={2}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-around",
                  padding: "0",
                  textAlign: "end",
                  marginTop: "13px",
                  marginLeft: "15px"
                }}
              >
                <Button
                  variant="contained"
                  onClick={() => {
                    if (searchCall) {
                      handleGetStockHistoryData(tabValue, filtereddata);
                      setSearchClearCall(true);
                    }
                  }}
                  disabled={isLoading}
                  startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                >
                  Search
                </Button>
                <Button
                  style={{ marginLeft: "15px" }}
                  variant="contained"
                  onClick={async () => {
                    setFilteredData({ s_status: -1, search: "" });
                    if (searchClearCall) {
                      setSearchClearCall(false);
                      handleGetStockHistoryData(tabValue, { s_status: -1, search: "" });
                    }
                  }}
                >
                  Clear
                </Button>
              </Grid>
            </Grid>
          </Card>

          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={tabValue} onChange={handleChange}>
              <Tab
                label={
                  <Box display="flex" alignItems="center" gap={0.2}>
                    <span>Stock In</span>
                    <CustomBadges counter={stockInCounter} />
                  </Box>
                }
              />
              <Tab
                label={
                  <Box display="flex" alignItems="center" gap={0.2}>
                    <span>Stock Out</span>
                    <CustomBadges counter={stockOutCounter} />
                  </Box>
                }
              />
            </Tabs>
          </Box>

          <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "10px"
              }}
            >
              <Button
                variant="contained"
                onClick={handleExportCSV}
                disabled={isLoading || exporting}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                {exporting ? "Exporting..." : "Export CSV"}
              </Button>

              <CSVLink
                ref={csvLinkRef}
                data={exportData}
                headers={tabValue === 0 ? stock_in_columns : stock_out_columns}
                filename="Stock_Report.csv"
                style={{ display: "none" }}
              />
            </Box>
            {tabValue === 0 ? (
              <DataTable
                pagination
                highlightOnHover
                paginationServer
                paginationTotalRows={totalRows}
                onChangePage={(p) => setPage(p)}
                onChangeRowsPerPage={(newPerPage) => setRowsPerPage(newPerPage)}
                columns={stockInColumns}
                data={stockData != null ? stockData : []}
                expandableRows
                expandableRowsComponent={stockInExpandableRow}
                progressPending={isLoading}
                progressComponent={<CustomLoader />}
              />
            ) : (
              <DataTable
                pagination
                highlightOnHover
                paginationServer
                paginationTotalRows={totalRows}
                onChangePage={(p) => setOutPage(p)}
                onChangeRowsPerPage={(newPerPage) => setOutRowsPerPage(newPerPage)}
                columns={stockOutColumns}
                conditionalRowStyles={conditionalRowStyles}
                data={stockData != null ? stockData : []}
                expandableRows
                expandableRowsComponent={stockInExpandableRow}
                progressPending={isLoading}
                progressComponent={<CustomLoader />}
              />
            )}
          </Card>
        </Container>
      </Page>

      {editStockModal && (
        <EditStockModal
          open={editStockModal}
          handleClose={toggleEditModal}
          rowData={stockInRowData}
          onSubmit={handleUpdateStockIn}
          loader={loader}
        />
      )}

      <Modal
        open={viewAttachmentModal}
        onClose={() => toggleViewAttachmentModal()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            height: "400px",
            overflow: "auto"
          }}
        >
          <Typography variant="h6" mb={2}>
            Attachments
          </Typography>

          {attachmentData?.receipt && !IsNotValue.includes(attachmentData?.receipt) ? (
            <Box mb={2}>
              <Box
                sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
              >
                <Typography variant="subtitle1">Stock In Receipt</Typography>
                <Button
                  size="small"
                  variant="outlined"
                  sx={{ mt: 1 }}
                  onClick={() =>
                    saveAs(
                      `${Routes.API_HOSTNAME}prime-stockin-receipt/${attachmentData.receipt}`,
                      attachmentData.receipt
                    )
                  }
                >
                  Download
                </Button>
              </Box>
              <img
                src={`${Routes.API_HOSTNAME}prime-stockin-receipt/${attachmentData.receipt}`}
                alt="Receipt"
                style={{
                  borderRadius: 8,
                  marginTop: 5,
                  width: "200px",
                  height: "200px",
                  objectFit: "contain"
                }}
              />
            </Box>
          ) : (
            <p style={{ display: "flex", justifyContent: "center", textAlign: "center" }}>
              There are no attachments
            </p>
          )}
        </Box>
      </Modal>

      <Modal open={revokeConfirmationModal} onClose={() => setRevokeConfirmationModal(false)}>
        <Box sx={approveModalStyle}>
          <Typography variant="h6" textAlign="center">
            Are you sure you want to Revoke this Product?
          </Typography>
          <Typography variant="body2" textAlign="center" color="text.secondary" mt={1}>
            The quantity will be returned to the Prime stock pool and the assignment will be
            marked as revoked.
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
            <Button
              variant="contained"
              color="error"
              className="btn btn-primary"
              onClick={async () => {
                await handleRevokeProduct(stockOutRowData);
                setRevokeConfirmationModal(false);
              }}
            >
              Yes, Revoke
            </Button>
            <Button variant="outlined" onClick={() => setRevokeConfirmationModal(false)}>
              Cancel
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
}

// Inline editor for a stock-in ledger line. Mirrors the privilege
// stockInsertUpdateModal edit mode but writes to prime_stock_history.
function EditStockModal({ open, handleClose, rowData, onSubmit, loader }) {
  const [qty, setQty] = useState(rowData?.qty || "");
  const [courierPrice, setCourierPrice] = useState(rowData?.courier_price || "");
  const [qcName, setQcName] = useState(rowData?.q_c_name || "");

  useEffect(() => {
    if (open) {
      setQty(rowData?.qty || "");
      setCourierPrice(rowData?.courier_price || "");
      setQcName(rowData?.q_c_name || "");
    }
  }, [open, rowData]);

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Typography
          variant="h6"
          component="h2"
          style={{ marginBottom: "5px", textAlign: "center" }}
        >
          Edit Stock
        </Typography>
        <hr />
        <Stack style={{ marginBottom: "15px" }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                style={{ marginTop: "15px" }}
                size="small"
                fullWidth
                autoComplete="off"
                type="number"
                required
                label="Quantity"
                value={qty}
                onChange={(e) => setQty(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                style={{ marginTop: "10px" }}
                size="small"
                fullWidth
                autoComplete="off"
                label="QC Name"
                value={qcName}
                onChange={(e) => setQcName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                style={{ marginTop: "10px" }}
                size="small"
                fullWidth
                autoComplete="off"
                type="number"
                label="Courier Price"
                value={courierPrice}
                onChange={(e) => setCourierPrice(e.target.value)}
              />
            </Grid>
            <Grid
              item
              sm={12}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center"
              }}
            >
              <Button
                variant="outlined"
                onClick={handleClose}
                style={{ marginTop: "15px", marginRight: "15px" }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                style={{ marginTop: "15px" }}
                disabled={loader}
                startIcon={loader && <CircularProgress size={20} color="inherit" />}
                onClick={() =>
                  onSubmit({
                    ...rowData,
                    qty: parseInt(qty),
                    q_c_name: qcName,
                    courier_price: parseFloat(courierPrice) || 0
                  })
                }
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </Modal>
  );
}
